import axios, { InternalAxiosRequestConfig } from "axios";
import { verifyLogin } from "./auth";

const axiosApp = axios.create({
  baseURL:
    process.env.REACT_APP_ENV === "production"
      ? "https://us-central1-thebestbarberplace.cloudfunctions.net/app"
      : "https://us-central1-thebestbarberplace-dev.cloudfunctions.net/app",
});

const requestHandler = async (request: InternalAxiosRequestConfig) => {
  request.headers["Access-Control-Allow-Methods"] = "*";

  let token = await verifyLogin();
  if (token) request.headers["Authorization"] = `Bearer ${token}`;
  return request;
};

[axiosApp].forEach((item) => {
  item.interceptors.request.use(requestHandler);
});

export { axiosApp };
export * from "./auth";
export * from "./clients";
export * from "./appointments";
export * from "./profile";
export * from "./custom-lunchs";
